export type PixelToRemConversionValue = 'string' | 'number';

// function pixelToRemConversion<T = string>(pixel: number): string;
// function pixelToRemConversion<T = string>(pixel: number, rootFontSize: number): string;
// function pixelToRemConversion<T = number>(pixel: number): number;
// function pixelToRemConversion<T = number>(pixel: number, rootFontSize: number): number;
function pixelToRemConversion(pixel: number, rootFontSize: number, as: 'string'): string;
function pixelToRemConversion(pixel: number, rootFontSize: number, as: 'number'): number;
function pixelToRemConversion(
  pixel: number,
  rootFontSize: number = 16,
  as: PixelToRemConversionValue = 'number'
): string | number {
  let conversionValue = pixel / rootFontSize;

  if (as === 'string') {
    return `${conversionValue}rem`;
  }

  return conversionValue;
}

export { pixelToRemConversion };
